import React from 'react';
import './SectionGridBackground.css';

const SectionGridBackground = () => (
  <div className="section-grid-bg" aria-hidden="true">
    <div className="section-grid" />
  </div>
);

export default SectionGridBackground;
